module.exports = __webpack_public_path__ + "img/truck.e6a81625.svg";